// @ts-strict-ignore
import { LocalizedStringValueVO, StringValueInLocalesVO } from '@project/components/article/model/vo/property.vo';
import { LocaleResourceManager } from '../manager/locale-resource.manager';

export class LocaleUtils {

  public static readonly DEFAULT_LOCALE = 'de_DE';
  public static readonly ARTICLE_TYPE_LOCALE_KEY_PREFIX: string = 'articleType.';
  public static readonly DRILLING_HOLE_TYPE_LOCALE_KEY_PREFIX: string = 'drillingHoleType.';
  public static readonly LABELING_CATEGORY_LOCALE_KEY_PREFIX: string = 'labelingCategory.';

  public static getValue(localeValue: StringValueInLocalesVO, locale: string): string {
    if (!localeValue) {
      return null;
    }
    return LocaleUtils.getValueInArray(localeValue.localizedValues, locale);
  }

  public static getValueInArray(localeValues: LocalizedStringValueVO[], locale: string): string {
    if (!localeValues) {
      return null;
    }
    let localeIndependentValue: string = null;
    for (const localeValue of localeValues) {
      if (localeValue.localeKey === locale) {
        return localeValue.stringValue;
      } else if (!localeValue.localeKey) {
        localeIndependentValue = localeValue.stringValue;
      }
    }
    return localeIndependentValue;
  }

  public static getValueByLocaleChain(localeValue: StringValueInLocalesVO, localeChain: string[]): string {
    if (!localeValue) {
      return;
    }
    if (!localeChain || !localeChain.length) {
      return LocaleUtils.getValue(localeValue, null);
    } else {
      return localeChain
        .map((locale: string) => LocaleUtils.getValue(localeValue, locale))
        .find((value: string) => !!value);
    }
  }

  public static getValueInArrayByLocaleChain(localeValues: LocalizedStringValueVO[], localeChain: string[]): string {
    if (!localeValues || !localeValues.length) {
      return null;
    }
    if (!localeChain || !localeChain.length) {
      return LocaleUtils.getValueInArray(localeValues, null);
    } else {
      return localeChain
        .map(locale => LocaleUtils.getValueInArray(localeValues, locale))
        .find(x => !!x);
    }
  }

  public static getLocalizedArticleType(localeResourceManager: LocaleResourceManager, articleTypeId: number): string {
    if (isNaN(articleTypeId)) {
      return null;
    }
    return localeResourceManager.findValueByKey(LocaleUtils.ARTICLE_TYPE_LOCALE_KEY_PREFIX + articleTypeId);
  }

  public static getLocalizedDrillingHoleType(localeResourceManager: LocaleResourceManager, holeType: string): string {
    if (!holeType) {
      return null;
    }
    return localeResourceManager.getValueByKey(LocaleUtils.DRILLING_HOLE_TYPE_LOCALE_KEY_PREFIX + holeType);
  }

  public static getLocalizedLabelingCategory(localeResourceManager: LocaleResourceManager, labelingCategory: string): string {
    if (!labelingCategory) {
      return null;
    }
    return localeResourceManager.getValueByKey(LocaleUtils.getLabelingCategoryTranslateKey(labelingCategory), null, true);
  }

  public static getLabelingCategoryTranslateKey(labelingCategory: string): string {
    return LocaleUtils.LABELING_CATEGORY_LOCALE_KEY_PREFIX + labelingCategory;
  }

}
